import { LINK_OF_ALL_PAGES } from "./common";

const E_COMMERCE = "E-commerce";
const TRAVEL_HOSPITALITY = "Travel and Hospitality";
const REAL_ESTATE = "Real Estate";
const E_COMMERCE_DATA_SERVICES = "eCommerce App Data Scraping Services";
const FOOD_GROCERY_DATA_SERVICES = "Food & Grocery Data Scraping Services";
const TRAVEL_DATA_SERVICES = "Travel Data Scraping Services";
const SOCIAL_MEDIA_DATA_SERVICES = "Social Media Data Scraping Services";
const REAL_ESTATE_DATA_SERVICES = "Real Estate Data Scraping Services";
const OTT_MEDIA_MEDIA_DATA_SERVICES = "OTT Media Data Scraping Services";
const BUTTON_LINK = LINK_OF_ALL_PAGES.mainPages.contactUs;
const CASE_STUDY_BACKGROUND_IMAGE =
  "url(/assets/data-solution/casestudybgimage.webp)";
  
export const ENTERPRISE_WEB_TAB_DATA = {
  tabData: {
    leftTabData: [
      {
        id: 1,
        title: E_COMMERCE,
      },
      {
        id: 2,
        title: TRAVEL_HOSPITALITY,
      },
      {
        id: 3,
        title: REAL_ESTATE,
      },
    ],
    RightTabData: [
      {
        id: 1,
        title: E_COMMERCE,
        description:
          "In the competitive e-commerce landscape, enterprise web scraping services offer vital insights for businesses. Through advanced data extraction techniques, companies can analyze market trends, consumer behavior, and competitor strategies in real-time. By leveraging these insights, businesses can optimize pricing strategies, enhance product offerings, and gain a competitive edge. Automated data analysis enables swift adaptation to market changes and informed decision-making, driving growth and profitability in the e-commerce sector.",

        img: "/assets/data-solution/ecommercedatascraping.webp",
        alt: E_COMMERCE,
        links: [
          { id: 1, linkText: "Amazon" },
          { id: 2, linkText: "Lowes" },
          { id: 3, linkText: "Tmall" },
          { id: 4, linkText: "Lazada" },
          { id: 5, linkText: "Shopee" },
        ],
      },
      {
        id: 2,
        title: TRAVEL_HOSPITALITY,
        description:
          "Enterprise web scraping services are essential for businesses in the travel and hospitality sector. By monitoring competitor pricing, analyzing customer reviews, and tracking market trends, companies can adapt quickly to changing consumer preferences. Automated data extraction and analysis empower businesses to make data-driven decisions, optimize strategies, and enhance competitiveness in the industry.",
        img: "/assets/data-solution/socialmediadatascraping.webp",
        alt: TRAVEL_HOSPITALITY,
        links: [
          { id: 1, linkText: "Booking" },
          { id: 2, linkText: "Expedia" },
          { id: 3, linkText: "Airbnb" },
          { id: 4, linkText: "Agoda" },
          { id: 5, linkText: "Trivago" },
        ],
      },
      {
        id: 3,
        title: REAL_ESTATE,
        description:
          "In the real estate market, enterprise web scraping services provide valuable insights for businesses. By monitoring property listings, tracking market trends, and analyzing pricing fluctuations, companies can identify opportunities and make informed investment decisions. Web scraping streamlines data collection, enabling businesses to stay ahead of the competition and maximize profitability in the dynamic real estate sector.",
        img: "/assets/data-solution/realestatedatascraping.webp",
        alt: REAL_ESTATE,
        links: [
          { id: 1, linkText: "Zillow" },
          { id: 2, linkText: "Trulia" },
          { id: 3, linkText: "Redfin" },
          { id: 4, linkText: "Realtor" },
          { id: 5, linkText: "RealtyTrac" },
        ],
      },
    ],
  },
};
export const ENTERPRISE_WEB_ACCORDION_DATA = [
  {
    id: 1,
    eventKey: 0,
    title: E_COMMERCE,
    description:
      "In the competitive e-commerce landscape, enterprise web scraping services offer vital insights for businesses. Through advanced data extraction techniques, companies can analyze market trends, consumer behavior, and competitor strategies in real-time. By leveraging these insights, businesses can optimize pricing strategies, enhance product offerings, and gain a competitive edge. Automated data analysis enables swift adaptation to market changes and informed decision-making, driving growth and profitability in the e-commerce sector.",
    src: "/assets/data-solution/ecommercedatascraping.webp",
    compony: [
      { id: 1, componyName: "Amazon" },
      { id: 2, componyName: "Lowes" },
      { id: 3, componyName: "Tmall" },
      { id: 4, componyName: "Lazada" },
      { id: 5, componyName: "Shopee" },
    ],
  },
  {
    id: 2,
    eventKey: 3,
    title: TRAVEL_HOSPITALITY,
    description:
      "Enterprise web scraping services are essential for businesses in the travel and hospitality sector. By monitoring competitor pricing, analyzing customer reviews, and tracking market trends, companies can adapt quickly to changing consumer preferences. Automated data extraction and analysis empower businesses to make data-driven decisions, optimize strategies, and enhance competitiveness in the industry.",
    src: "/assets/data-solution/socialmediadatascraping.webp",
    compony: [
      { id: 1, componyName: "Booking" },
      { id: 2, componyName: "Expedia" },
      { id: 3, componyName: "Airbnb" },
      { id: 4, componyName: "Agoda" },
      { id: 5, componyName: "Trivago" },
    ],
  },
  {
    id: 3,
    eventKey: 4,
    title: REAL_ESTATE,
    description:
      "Transform your real estate ventures with our specialized <b>Mobile App Scraping Services.</b> Crafted for the dynamic data needs of the industry, our solutions provide real-time, accurate insights. From tracking property listings to analyzing market trends, rely on our specialized service for tailored data extraction that fuels strategic decision-making. Stay ahead in the real estate sector with our dedicated <b>Mobile App Scraping Services,</b> ensuring you have the essential information to optimize property management, make informed investments, and excel in the competitive real estate market.",
    src: "/assets/data-solution/realestatedatascraping.webp",
    compony: [
      { id: 1, componyName: "Zillow" },
      { id: 2, componyName: "Trulia" },
      { id: 3, componyName: "Redfin" },
      { id: 4, componyName: "Realtor" },
      { id: 5, componyName: "RealtyTrac" },
    ],
  },
];
export const OUR_SOLUTION_CARD_DATA = [
  {
    id: 1,
    title: "Personalized Solutions",
    description:
      "Obtain customized scraping services tailored to your enterprise's unique data needs and goals, ensuring maximum efficiency and effectiveness in data extraction.",
  },
  {
    id: 2,
    title: "Seamless Scalability",
    description:
      "Effortlessly expand scraping capabilities to accommodate business growth without compromising performance or data quality, ensuring sustained success in scalability.",
  },
  {
    id: 3,
    title: "Data Accuracy Assurance",
    description:
      "Guarantee precise, reliable, and consistent data extraction to facilitate informed decision-making and strategic planning initiatives, ensuring high-quality data accuracy.",
  },
  {
    id: 4,
    title: "Cutting-Edge Technology",
    description:
      "Utilize advanced tools and techniques for efficient and effective data harvesting, ensuring a competitive edge in the market with cutting-edge technology.",
  },
  {
    id: 5,
    title: "Compliance and Security Measures",
    description:
      "Rest assured with strict adherence to data privacy regulations and robust security protocols, safeguarding sensitive information and ensuring compliance with regulations.",
  },
  {
    id: 6,
    title: "Dedicated Customer Support",
    description:
      "Access expert assistance and ongoing guidance to optimize scraping efforts, unlocking the full potential of your data initiatives with dedicated customer support.",
  },
];
export const MOBILE_APP_TAB_DATA = {
  tabData: {
    leftTabData: [
      {
        id: 1,
        title: E_COMMERCE_DATA_SERVICES,
      },
      {
        id: 2,
        title: FOOD_GROCERY_DATA_SERVICES,
      },
      {
        id: 3,
        title: TRAVEL_DATA_SERVICES,
      },
      {
        id: 4,
        title: SOCIAL_MEDIA_DATA_SERVICES,
      },
      {
        id: 5,
        title: REAL_ESTATE_DATA_SERVICES,
      },
      {
        id: 6,
        title: OTT_MEDIA_MEDIA_DATA_SERVICES,
      },
    ],
    RightTabData: [
      {
        id: 1,
        title: E_COMMERCE_DATA_SERVICES,
        description:
          "Elevate your e-commerce game with our <b>Mobile App Scraping Services.</b> Tailored for the dynamic needs of the industry, our solutions provide real-time, accurate insights. From monitoring product trends to market analysis, trust us to deliver customized data that enhances decision-making. Stay ahead in the digital landscape with our specialized service designed exclusively for the demands of the e-commerce sector.",

        img: "/assets/data-solution/ecommercedatascraping.webp",
        alt: E_COMMERCE_DATA_SERVICES,
        links: [
          { id: 1, linkText: "Amazon" },
          { id: 2, linkText: "Lowes" },
          { id: 3, linkText: "Tmall" },
          { id: 4, linkText: "Lazada" },
          { id: 5, linkText: "Shopee" },
        ],
      },
      {
        id: 2,
        title: FOOD_GROCERY_DATA_SERVICES,
        description:
          "Transform your food and grocery business with our specialized <b>Mobile App Scraping Services</b> Designed to cater to the unique data requirements of the industry, our solutions provide real-time, precise insights. From monitoring product availability to tracking market trends, count on us for tailored data extraction that enhances decision-making. Stay competitive in the food and grocery sector with our dedicated Mobile App Scraping Services, ensuring you have the critical information to optimize operations and drive success.",
        img: "/assets/data-solution/foodgrocerydatascraping.webp",
        alt: FOOD_GROCERY_DATA_SERVICES,
        links: [
          { id: 1, linkText: "Zomato" },
          { id: 2, linkText: "Swiggy" },
          { id: 3, linkText: "Kroger" },
          { id: 4, linkText: "Instacart" },
          { id: 5, linkText: "Instamart" },
        ],
      },
      {
        id: 3,
        title: TRAVEL_DATA_SERVICES,
        description:
          "Revolutionize your travel industry presence with our <b>Mobile App Scraping Services.</b> Tailored for the dynamic data landscape of travel, our solutions offer real-time, accurate insights. From monitoring booking trends to analyzing market dynamics, trust our specialized service for customized data extraction that fuels strategic decision-making. Stay ahead in the travel sector with our dedicated Mobile App Scraping Services, providing the essential information you need to optimize services, enhance customer experiences, and navigate the competitive travel landscape effectively.",
        img: "/assets/data-solution/traveldatascraping.webp",
        alt: TRAVEL_DATA_SERVICES,
        links: [
          { id: 1, linkText: "TripAdvisor" },
          { id: 2, linkText: "Agoda" },
          { id: 3, linkText: "Expedia" },
          { id: 4, linkText: "Airbnb" },
          { id: 5, linkText: "MakeMyTrip" },
        ],
      },
      {
        id: 4,
        title: SOCIAL_MEDIA_DATA_SERVICES,
        description:
          "Elevate your social media strategy with our cutting-edge <b>Mobile App Scraping Services.</b> Tailored for the ever-evolving data landscape of social platforms, our solutions deliver real-time, precise insights. From monitoring user engagement to tracking trends, trust our specialized service for customized data extraction that fuels informed decision-making. Stay ahead in the social media realm with our dedicated <b>Mobile App Scraping Services,</b> providing the crucial information you need to optimize content, target audiences effectively, and thrive in the competitive social media landscape.",
        img: "/assets/data-solution/socialmediadatascraping.webp",
        alt: SOCIAL_MEDIA_DATA_SERVICES,
        links: [
          { id: 1, linkText: "LinkedIn" },
          { id: 2, linkText: "Twitter" },
          { id: 3, linkText: "Youtube" },
          { id: 4, linkText: "Tiktok" },
          { id: 5, linkText: "Pinterest" },
        ],
      },
      {
        id: 5,
        title: REAL_ESTATE_DATA_SERVICES,
        description:
          "Transform your real estate ventures with our specialized <b>Mobile App Scraping Services.</b> Crafted for the dynamic data needs of the industry, our solutions provide real-time, accurate insights. From tracking property listings to analyzing market trends, rely on our specialized service for tailored data extraction that fuels strategic decision-making. Stay ahead in the real estate sector with our dedicated <b>Mobile App Scraping Services,</b> ensuring you have the essential information to optimize property management, make informed investments, and excel in the competitive real estate market.",
        img: "/assets/data-solution/realestatedatascraping.webp",
        alt: REAL_ESTATE_DATA_SERVICES,
        links: [
          { id: 1, linkText: "Zillow" },
          { id: 2, linkText: "HomeFinder" },
          { id: 3, linkText: "RealtyTrac" },
        ],
      },
      {
        id: 6,
        title: OTT_MEDIA_MEDIA_DATA_SERVICES,
        description:
          "Unleash the potential of your OTT media platform with our specialized <b>Mobile App Scraping Services.</b> Tailored for the dynamic data landscape of digital streaming, our solutions deliver real-time, accurate insights. From monitoring content consumption trends to analyzing viewer preferences, trust our specialized service for customized data extraction that fuels strategic decision-making. Stay ahead in the OTT media realm with our dedicated <b>Mobile App Scraping Services,</b> providing the essential information you need to optimize content delivery, enhance user experiences, and navigate the competitive digital streaming landscape effectively.",
        img: "/assets/data-solution/ottmediadatascraping.webp",
        alt: OTT_MEDIA_MEDIA_DATA_SERVICES,
        links: [
          { id: 1, linkText: "Netflix" },
          { id: 2, linkText: "Amazon Prime Video" },
          { id: 3, linkText: "Disney+" },
        ],
      },
    ],
  },
};
export const MOBILE_APP_ACCORDION_DATA = [
  {
    id: 1,
    eventKey: 0,
    title: E_COMMERCE_DATA_SERVICES,
    description:
      "Elevate your e-commerce game with our <b>Mobile App Scraping Services.</b> Tailored for the dynamic needs of the industry, our solutions provide real-time, accurate insights. From monitoring product trends to market analysis, trust us to deliver customized data that enhances decision-making. Stay ahead in the digital landscape with our specialized service designed exclusively for the demands of the e-commerce sector.",
    src: "/assets/data-solution/ecommercedatascraping.webp",
    compony: [
      { id: 1, componyName: "Amazon" },
      { id: 2, componyName: "Lowes" },
      { id: 3, componyName: "Tmall" },
      { id: 4, componyName: "Lazada" },
      { id: 5, componyName: "Shopee" },
    ],
  },
  {
    id: 2,
    eventKey: 1,
    title: FOOD_GROCERY_DATA_SERVICES,
    description:
      "Transform your food and grocery business with our specialized <b>Mobile App Scraping Services</b> Designed to cater to the unique data requirements of the industry, our solutions provide real-time, precise insights. From monitoring product availability to tracking market trends, count on us for tailored data extraction that enhances decision-making. Stay competitive in the food and grocery sector with our dedicated Mobile App Scraping Services, ensuring you have the critical information to optimize operations and drive success.",
    src: "/assets/data-solution/foodgrocerydatascraping.webp",
    compony: [
      { id: 1, componyName: "Zomato" },
      { id: 2, componyName: "Swiggy" },
      { id: 3, componyName: "Kroger" },
      { id: 4, componyName: "Instacart" },
      { id: 5, componyName: "Instamart" },
    ],
  },
  {
    id: 3,
    eventKey: 2,
    title: TRAVEL_DATA_SERVICES,
    description:
      "Revolutionize your travel industry presence with our <b>Mobile App Scraping Services.</b> Tailored for the dynamic data landscape of travel, our solutions offer real-time, accurate insights. From monitoring booking trends to analyzing market dynamics, trust our specialized service for customized data extraction that fuels strategic decision-making. Stay ahead in the travel sector with our dedicated Mobile App Scraping Services, providing the essential information you need to optimize services, enhance customer experiences, and navigate the competitive travel landscape effectively.",
    src: "/assets/data-solution/traveldatascraping.webp",
    compony: [
      { id: 1, componyName: "TripAdvisor" },
      { id: 2, componyName: "Agoda" },
      { id: 3, componyName: "Expedia" },
      { id: 4, componyName: "Airbnb" },
      { id: 5, componyName: "MakeMyTrip" },
    ],
  },
  {
    id: 4,
    eventKey: 3,
    title: SOCIAL_MEDIA_DATA_SERVICES,
    description:
      "Elevate your social media strategy with our cutting-edge <b>Mobile App Scraping Services.</b> Tailored for the ever-evolving data landscape of social platforms, our solutions deliver real-time, precise insights. From monitoring user engagement to tracking trends, trust our specialized service for customized data extraction that fuels informed decision-making. Stay ahead in the social media realm with our dedicated <b>Mobile App Scraping Services,</b> providing the crucial information you need to optimize content, target audiences effectively, and thrive in the competitive social media landscape.",
    src: "/assets/data-solution/socialmediadatascraping.webp",
    compony: [
      { id: 1, componyName: "LinkedIn" },
      { id: 2, componyName: "Twitter" },
      { id: 3, componyName: "Youtube" },
      { id: 4, componyName: "Tiktok" },
      { id: 5, componyName: "Pinterest" },
    ],
  },
  {
    id: 5,
    eventKey: 4,
    title: REAL_ESTATE_DATA_SERVICES,
    description:
      "Transform your real estate ventures with our specialized <b>Mobile App Scraping Services.</b> Crafted for the dynamic data needs of the industry, our solutions provide real-time, accurate insights. From tracking property listings to analyzing market trends, rely on our specialized service for tailored data extraction that fuels strategic decision-making. Stay ahead in the real estate sector with our dedicated <b>Mobile App Scraping Services,</b> ensuring you have the essential information to optimize property management, make informed investments, and excel in the competitive real estate market.",
    src: "/assets/data-solution/realestatedatascraping.webp",
    compony: [
      { id: 1, componyName: "Zillow" },
      { id: 2, componyName: "HomeFinder" },
      { id: 3, componyName: "RealtyTrac" },
    ],
  },
  {
    id: 6,
    eventKey: 5,
    title: OTT_MEDIA_MEDIA_DATA_SERVICES,
    description:
      "Unleash the potential of your OTT media platform with our specialized <b>Mobile App Scraping Services.</b> Tailored for the dynamic data landscape of digital streaming, our solutions deliver real-time, accurate insights. From monitoring content consumption trends to analyzing viewer preferences, trust our specialized service for customized data extraction that fuels strategic decision-making. Stay ahead in the OTT media realm with our dedicated <b>Mobile App Scraping Services,</b> providing the essential information you need to optimize content delivery, enhance user experiences, and navigate the competitive digital streaming landscape effectively.",
    src: "/assets/data-solution/ottmediadatascraping.webp",
    compony: [
      { id: 1, componyName: "Netflix" },
      { id: 2, componyName: "Amazon Prime Video" },
      { id: 3, componyName: "Disney+" },
    ],
  },
];
export const OUR_SOLUTION_CARD_MOBILE_DATA = [
  {
    id: 1,
    title: "Tailored Solutions for Your Needs",
    description:
      "Benefit from precision data extraction tailored to your unique requirements. ultroNeous offers personalized and efficient scraping experiences, delivering insights aligned perfectly with your goals.",
  },
  {
    id: 2,
    title: "Up-to-Date and Relevant Data",
    description:
      "Stay ahead with ultroNeous's commitment to delivering timely and relevant data. Our services adapt to the dynamic mobile app landscape, ensuring you receive accurate insights for informed decision-making.",
  },
  {
    id: 3,
    title: "Seamless Android and iOS Integration",
    description:
      "Effortlessly collect app data across platforms with ultroNeous's specialized Android and iOS scraping services. Our comprehensive solution ensures seamless integration, maximizing efficiency in gathering insights.",
  },
  {
    id: 4,
    title: "Cutting-Edge Technology for Accuracy",
    description:
      "Experience precision and reliability with ultroNeous's advanced scraping technology. Our tools and methodologies set the standard for accuracy, providing dependable insights for your mobile app analytics needs.",
  },
  {
    id: 5,
    title: "Reliable and Secure Data Handling",
    description:
      "Trust ultroNeous for secure and confidential data handling. With robust security measures, we ensure the integrity of your information, offering a reliable environment for your scraping requirements.",
  },
  {
    id: 6,
    title: "Legal Compliance Assurance",
    description:
      "Maintain legal compliance with ultroNeous's app scraping. We ensure data extraction adheres to privacy laws and industry regulations effectively.",
  },
];
export const TESTIMONIALS_SLIDER_DATA = [
  {
    id: 1,
    src: "/assets/data-solution/SarahJohnson.webp",
    alt: "Sarah Johnson",
    title:
      "Incredible results! ultroNeous exceeded our expectations in data scraping. Kudos to the team!",
    clientName: "Sarah Johnson",
  },
  {
    id: 2,
    src: "/assets/data-solution/MichaelRodriguez.webp",
    alt: "MichaelRodriguez",
    title:
      "Reliable and efficient data scraping services. ultroNeous has become our go-to partner.",
    clientName: "Michael Rodriguez",
  },
  {
    id: 3,
    src: "/assets/data-solution/EmilyTurner.webp",
    alt: "EmilyTurner",
    title:
      "Outstanding accuracy and speed! ultroNeous transformed our data game. Highly recommend!",
    clientName: "Emily Turner",
  },
  {
    id: 4,
    src: "/assets/data-solution/JamesWilliams.webp",
    alt: "JamesWilliams",
    title:
      "Top-notch service! ultroNeous delivered precise data on time, every time. Very impressed!",
    clientName: "James Williams",
  },
  {
    id: 5,
    src: "/assets/data-solution/SmithAmanda.webp",
    alt: "SmithAmanda",
    title:
      "ultroNeous made data scraping seamless for us. Their expertise is unmatched.",
    clientName: "Smith Amanda",
  },
];
export const WEB_API_CARD_DATA = [
  {
    id: 1,
    title: "Efficiency in Data Retrieval",
    description:
      "Experience swift, effective data retrieval with our optimized services, gathering diverse information from online sources efficiently.",
  },
  {
    id: 2,
    title: "Customization for Unique Needs",
    description:
      "Tailor data extraction parameters to your unique project requirements. Enjoy flexible API services that deliver precisely the information your business demands.",
  },
  {
    id: 3,
    title: "Effortless Integration",
    description:
      "Seamlessly incorporate our Web Scraping API into your systems. With straightforward documentation and robust support, integration is swift and hassle-free.",
  },
  {
    id: 4,
    title: "Cost-Effectiveness",
    description:
      "Access valuable data affordably. Our services provide cost-effective data extraction solutions, saving you time and money without extensive resources or manual labor.",
  },
  {
    id: 5,
    title: "Continuous Support and Updates",
    description:
      "Gain a reliable partner with our services. Benefit from ongoing support and updates to align your data extraction processes with the latest technological advancements.",
  },
  {
    id: 6,
    title: "Robust Security Measures",
    description:
      "Ensure data confidentiality and integrity. Our services feature robust security protocols, safeguarding your data throughout the extraction process. Trust us for secure information handling.",
  },
];
export const DATA_SOLUTION_COUNT_DATA = [
  { id: 1, end: 40, sign: "+", title: "Employee Strength" },
  { id: 2, end: 100, sign: "+", title: "Successful Projects" },
  { id: 3, end: 98, sign: "%", title: "Positive Feedback" },
  { id: 4, end: 150, sign: "+", title: "Clients Worldwide" },
  { id: 5, end: 200, sign: "+", title: "Data Feeds Every Day" },
];
export const OUR_SOLUTION_CARD_DATA_SOLUTION_DATA = [
  {
    id: 1,
    title: "E-Commerce Products Data",
    description:
      "Explore ultroNeous' E-Commerce Products Data solutions: comprehensive product insights, pricing trends, competitor analysis, and tailored data strategies for your business.",
  },
  {
    id: 2,
    title: "Pricing Intelligence",
    description:
      "Optimize your pricing strategy for maximum revenue and profit growth. Ensure your products are competitively priced with our expert Price Intelligence.",
  },
  {
    id: 3,
    title: "Brand Monitoring",
    description:
      "Protect and elevate your brand presence. Our Brand Monitoring services ensure you stay ahead, maintaining brand integrity and fostering positive online perception.",
  },
  {
    id: 4,
    title: "Food delivery & Grocery Data",
    description:
      "Empower your food and grocery business with data-driven success. Unlock valuable insights through our specialized Food Delivery & Grocery Data services, shaping a thriving future.",
  },
  {
    id: 5,
    title: "Real Estate and Property Data",
    description:
      "Unlock your real estate strategy with our comprehensive Real Estate and Property Data services. Gain nuanced market insights, property trends, and competitive advantages for informed decision-making excellence.",
  },
  {
    id: 6,
    title: "SERP Scraping API",
    description:
      "Drive your SEO strategy with UltroNeous SERP Scraping API. Gain real-time insights into search engine rankings, outperform competitors, and enhance your online visibility.",
  },
];
export const SERVICES_PROVIDER_CARD_DATA = [
  {
    id: 1,
    title: "Enterprise Web Scraping",
    description:
      "Experience seamless data extraction with ultroNeous Enterprise Web Scraping Services. Unlock valuable insights, streamline operations, and stay ahead in the competitive landscape.",
    link: LINK_OF_ALL_PAGES.services.enterPriseWebScrapingService,
    alt: "Web Scraping Services",
    src: "/assets/data-solution/webscraping.webp",
  },
  {
    id: 2,
    title: "Mobile App Scraping",
    description:
      "Elevate your mobile app strategy with ultroNeous Mobile App Scraping Services. Gain a competitive edge by extracting valuable data, enhancing user experience, and optimizing performance.",
    link: LINK_OF_ALL_PAGES.services.mobileAppScrapingServices,
    alt: "Mobile App Scraping",
    src: "/assets/data-solution/mobilescraping.webp",
  },
  {
    id: 3,
    title: "Web Scraping API",
    description:
      "Empower your applications with ultroNeous Web Scraping API. Access real-time & accurate data. Elevate your projects with seamless integration and unlock the full potential of web scraping innovation.",
    link: LINK_OF_ALL_PAGES.services.webScrapingApi,
    alt: "Web Scraping API",
    src: "/assets/data-solution/webapi.webp",
  },
];
export const OUR_INDUSTRIES_DATA = [
  {
    id: 1,
    title: "E-Commerce Data Scraping",
    description:
      "Elevate your e-commerce game with our tailored Data Scraping solutions. From competitor pricing analysis to trend forecasting, we help you stay ahead. Gain insights to optimize your product offerings and enhance customer experience seamlessly.",
    src: "/assets/data-solution/ecommercedatascraping.webp",
    alt: "E-Commerce Data Scraping",
    links: [
      { linkText: "Amazon" },
      { linkText: "Lowes" },
      { linkText: "Tmall" },
      { linkText: "Lazada" },
      { linkText: "Shopee" },
    ],
  },
  {
    id: 2,
    title: "Food & Grocery",
    description:
      "Transform your food and grocery business with our Data Scraping expertise. Monitor market trends, analyze competitor pricing, and optimize inventory management effortlessly. Stay agile in a dynamic industry to meet customer demands effectively.",
    src: "/assets/data-solution/foodgrocerydatascraping.webp",
    alt: "Food & Grocery Data Scraping",
    links: [
      { linkText: "Zomato" },
      { linkText: "Swiggy" },
      { linkText: "Kroger" },
      { linkText: "Instacart" },
      { linkText: "Instamart" },
    ],
  },
  {
    id: 3,
    title: "Travel",
    description:
      "Embark on a journey to success with our Travel Data Scraping services. Gain insights into traveler preferences, destination trends, and competitor strategies. Let data be your compass, guiding you towards exceptional experiences and business growth in the travel industry.",
    src: "/assets/data-solution/traveldatascraping.webp",
    alt: "Travel Data Scraping",
    links: [
      { linkText: "TripAdvisor" },
      { linkText: "Agoda" },
      { linkText: "Expedia" },
      { linkText: "Airbnb" },
      { linkText: "MakeMyTrip" },
    ],
  },
  {
    id: 4,
    title: "Social Media",
    description:
      "Unlock the power of social media with our Data Scraping solutions. Monitor trends, analyze audience behavior, and track competitor strategies seamlessly. Elevate your social presence and engagement, driving impactful decisions for business growth and brand success.",
    src: "/assets/data-solution/socialmediadatascraping.webp",
    alt: "Social Media Data Scraping",
    links: [
      { linkText: "LinkedIn" },
      { linkText: "Twitter" },
      { linkText: "Youtube" },
      { linkText: "Tiktok" },
      { linkText: "Pinterest" },
    ],
  },
  {
    id: 5,
    title: "Real Estate",
    description:
      "Navigate the real estate landscape with our Data Scraping expertise. Gain insights into market trends, property values, and investment opportunities. Let data be your guide in making informed decisions and achieving success in the dynamic world of real estate.",
    src: "/assets/data-solution/realestatedatascraping.webp",
    alt: "Real Estate Data Scraping",
    links: [
      { linkText: "Zillow" },
      { linkText: "HomeFinder" },
      { linkText: "RealtyTrac" },
    ],
  },
  {
    id: 6,
    title: "OTT Media",
    description:
      "Dive into the world of OTT with our Data Scraping solutions. Analyze viewer preferences, content trends, and competitor strategies. Harness the power of data to optimize your content offerings and captivate audiences in the ever-evolving OTT industry.",
    src: "/assets/data-solution/ottmediadatascraping.webp",
    alt: "OTT Media Data Scraping",
    links: [
      { linkText: "Netflix" },
      { linkText: "Amazon Prime Video" },
      { linkText: "Disney+" },
    ],
  },
];
export const HERO_CAROUSEL_DATA = [
  {
    id: 1,
    title: "Unleash the Power of Data with Our Mobile App Scraping Services!",
    description:
      "Boost your business with our cutting-edge mobile app data scraping services. Extract valuable insights effortlessly and stay ahead in the competition.",
    backgroundImage: "url(/assets/data-solution/herocarouselbg.webp)",
    backgroundImageMobile:
      "url(/assets/data-solution/herocarouselmobilebg.webp)",
    link: BUTTON_LINK,
  },
  {
    id: 2,
    title: "Transform Real Estate Intelligence with Our Web Scraping Services!",
    description:
      "Elevate your real estate game with our powerful web scraping services. Unlock valuable market data, gain a competitive edge, and make informed decisions. Dive in today!",
    backgroundImage: "url(/assets/data-solution/herocarouselbg2.webp)",
    backgroundImageMobile:
      "url(/assets/data-solution/herocarouselmobilebg2.webp)",
    link: BUTTON_LINK,
  },
  {
    id: 3,
    title:
      "Revolutionize Your eCommerce Strategy with Our Data Scraping Services!",
    description:
      "Fuel growth with our eCommerce web data scraping. Gain insights on market trends, analyze competitors, and make strategic decisions. Elevate your business with us!",
    backgroundImage: "url(/assets/data-solution/herocarouselbg3.webp)",
    backgroundImageMobile:
      "url(/assets/data-solution/herocarouselmobilebg3.webp)",
    link: BUTTON_LINK,
  },
  {
    id: 4,
    title: "Feast on Insights with Our Food Delivery Data Scraping Services!",
    description:
      "Savor success in the food delivery industry. Leverage our data scraping services to analyze trends, optimize menus, and stay ahead of the competition.",
    backgroundImage: "url(/assets/data-solution/herocarouselbg4.webp)",
    backgroundImageMobile:
      "url(/assets/data-solution/herocarouselmobilebg4.webp)",
    link: BUTTON_LINK,
  },
];
export const CASE_STUDY_CAROUSEL_DATA = [
  {
    id: 1,
    backgroundColor: "#216D2D",
    title:
      "Empower Your Travel Decisions-Scrape Hotel Price Data from TripAdvisor",
    link: LINK_OF_ALL_PAGES.mainPages.home,
    alt: "alt",
    src: CASE_STUDY_BACKGROUND_IMAGE,
  },
  {
    id: 2,
    backgroundColor: "#216D2D",
    title:
      "Empower Your Travel Decisions-Scrape Hotel Price Data from TripAdvisor2",
    link: LINK_OF_ALL_PAGES.mainPages.home,
    alt: "alt2",
    src: CASE_STUDY_BACKGROUND_IMAGE,
  },
  {
    id: 3,
    backgroundColor: "#216D2D",
    title:
      "Empower Your Travel Decisions-Scrape Hotel Price Data from TripAdvisor3",
    link: LINK_OF_ALL_PAGES.mainPages.home,
    alt: "alt3",
    src: CASE_STUDY_BACKGROUND_IMAGE,
  },
  {
    id: 4,
    backgroundColor: "#216D2D",
    title:
      "Empower Your Travel Decisions-Scrape Hotel Price Data from TripAdvisor4",
    link: LINK_OF_ALL_PAGES.mainPages.home,
    alt: "alt4",
    src: CASE_STUDY_BACKGROUND_IMAGE,
  },
  {
    id: 5,
    backgroundColor: "#216D2D",
    title:
      "Empower Your Travel Decisions-Scrape Hotel Price Data from TripAdvisor5",
    link: LINK_OF_ALL_PAGES.mainPages.home,
    alt: "alt5",
    src: CASE_STUDY_BACKGROUND_IMAGE,
  },
];
